import { render } from "./Footer.vue?vue&type=template&id=867801d2&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=867801d2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-867801d2"

export default script